<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-loan__tcustbase}">
      <el-form :inline="true"  :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.custName" placeholder="姓名/企业名称" clearable></el-input>
        </el-form-item>

        <el-form-item>
            <!-- <el-select v-model="dataForm.companyId" filterable clearable placeholder="机构名称"  @change="getId">
              <el-option
                v-for="item in userType"
                :key="item.value"
                :label="item.label"
                :value="item.id"
                >
                </el-option>
            </el-select>
             -->
             <ren-dept-tree v-model="dataForm.companyId" :placeholder="$t('dept.title')" :query="true" ref="tree"></ren-dept-tree>
          </el-form-item>
        <el-form-item>
            <el-date-picker
                    v-model="date"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    @change="getTimes"
                    unlink-panels>
            </el-date-picker>
          </el-form-item>
        <el-form-item>
          <el-button @click="getDataList('dept')">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('loan:tcustbase:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item> -->
        
        <!-- <el-form-item>
          <el-button v-if="$hasPermission('loan:tcustbase:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item> -->
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column prop="companyName" label="资金方" header-align="center" align="center"></el-table-column>
        <el-table-column prop="custName" label="姓名/企业名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="idNo" label="证件号" header-align="center" align="center">
          <template slot-scope="scope">
            <div>{{scope.row.idNo}}</div>
            <el-button class="look-idNo" v-if="scope.row.frontUrl && scope.row.backUrl"  type="text" size="small" @click="lookIdNo(scope.row)">查看证件</el-button>
  
          </template>
        </el-table-column>
       
        <el-table-column prop="mobile" label="手机号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="companyType" label="职业" header-align="center" align="center"></el-table-column>
        <el-table-column prop="income" label="月收入" header-align="center" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.income">{{scope.row.income.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="录入日期" header-align="center" align="center"></el-table-column>
        <el-table-column prop="" label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('loan:tcustbase:entering')"  type="text" size="small" @click="entering(scope.row.id,scope.row)">录入借款订单</el-button>
            <!-- <el-button v-if="$hasPermission('loan:tcustbase:update')"  type="text" size="small" @click="enteringv(scope.row.id)">查看贷款信息</el-button> -->
            <el-button v-if="$hasPermission('loan:tcustbase:update')"  type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">修改借款人</el-button>

            <!-- <el-button  type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">查看贷款信息</el-button> -->
          </template>
        </el-table-column>
      
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @sendValue="handleReceivedValue" @refreshDataList="getDataList" @FSaddOrUpdateCVisible="showEntering()" ></add-or-update>
      <add-or-updatee v-if="addOrUpdateCVisible" ref="addOrUpdatec"  @signedFS="signed = true" ></add-or-updatee>
      <AddOrUpdateev v-if="addOrUpdateCVisiblev" ref="addOrUpdatecv"   ></AddOrUpdateev>
      <!-- 查看证件弹窗 -->
      <el-dialog
      :visible.sync="isLookIdNo">
      <div class="look-title" slot="title">
        <img src="../../../assets/img/证件.png" alt="">
        <span>借款人证件</span>
      </div>
        <div class="look-dialog">
          <div class="left-dialog">
            <div class="title">身份证头像面</div>
            <div class="idNO-img">
              <div class="img-box">
                <img :src="frontUrl" alt="">
              </div>
            </div>
          </div>
          <div class="right-dialog">
            <div class="title">身份证国徽面</div>
            <div class="idNO-img">
              <div class="img-box">
                <img :src="backUrl" alt="">
              </div>
            </div>
            
          </div>
        </div>
  
    </el-dialog>
      <!-- <add-or-updateeloan v-if="addOrUpdateCloanVisible" ref="addOrUpdatecloan" @iscodeFS="code = true" ></add-or-updateeloan> -->
      <!--  -->
      <el-card class="box-card" v-if="signed">
               <p>中运交投</p>
               <h3>请通过 短信中链接进行签约</h3>
               <ul>
                 <li><span>手机号   </span> <span>15812345678</span></li>
                 <li><span>借款编号   </span> <span > 01210000001  </span></li>
                 <li><span>签约有效时间   </span> <span> 1小时 </span></li>
               </ul>
               <div class="card-btn">
                  <button @click="signed = false">取消</button> 
                  <button @click="editRecord()">修改借款记录</button>
                  <button @click="signedOK()">
                      已签约去放款
                  </button>
               </div>
          </el-card>
          <!-- 请输入支付密码 -->
          <el-card class="box-card1" v-if="code">
             <p>中运交投</p>
             <p class="p2">请输入支付密码</p>
             <div>
                <div class="input-box">
                <div class="code-item" :class="codeValue.length == 0 && inputFocus ? 'code-item-active' : ''">{{codeValue[0] ? '*' : ''}}</div>
                <div class="code-item" :class="codeValue.length == 1 && inputFocus ? 'code-item-active' : ''">{{codeValue[1] ? '*' : ''}} </div>
                <div class="code-item" :class="codeValue.length == 2 && inputFocus ? 'code-item-active' : ''">{{codeValue[2] ? '*' : ''}}</div>
                <div class="code-item" :class="codeValue.length == 3 && inputFocus ? 'code-item-active' : ''">{{codeValue[3] ? '*' : ''}}</div>
                <div class="code-item" :class="codeValue.length == 4 && inputFocus ? 'code-item-active' : ''">{{codeValue[4] ? '*' : ''}}</div>
                <div class="code-item" :class="codeValue.length >= 5 && inputFocus ? 'code-item-active' : ''">{{codeValue[5] ? '*' : ''}}</div>
                <input 
                  class="input-code"
                  v-model="codeValue"
                  :maxlength="6"
                  type="tel"
                  @blur="codeInputBlur"
                  @focus="codeInputFocus"
                  @input="codeInputChange" />
              </div>
             </div>
            <div class="footer-btn">
              <el-button @click="code = false">取消</el-button>
              <el-button @click="codeOk()">确认</el-button>
            </div>

        </el-card>
        <!-- 提示弹窗 -->
        <el-dialog
          title="提示"
          :visible.sync="isTip"
          width="30%"
          :close-on-click-modal="false" :close-on-press-escape="false"
          >
            <span>{{tipText}}</span>
            <span slot="footer" class="dialog-footer">
              <el-button v-if="isPresentAccount == true  || isPresentCapitalSide == false" @click="isTip = false">取 消</el-button>
              <el-button v-if="isPresentAccount == true"  @click="changeHandle(custBaseId)">修改借款人</el-button>
              <el-button v-if="isPresentAccount == true" type="primary" :disabled="isDisabled" @click="entering1(custBaseId)">继续</el-button>
              <el-button  v-if="isPresentCapitalSide == false" type="primary" :disabled="isDisabled" @click="submitForm()">继续</el-button>
            </span>
        </el-dialog>
   
    </div>
  
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './tcustbase-add-or-update'
import AddOrUpdatee from './tcustbase-add-or-updatee'
import AddOrUpdateeloan from './tcustbase-add-or-updateeloan'
import AddOrUpdateev from './tcustbase-add-or-v'

export default {
  mixins: [mixinViewModule],
  data () {
    return {
      isDisabled:false,
      dataForm1:{},
      custBaseId:null,
      isPresentCapitalSide:false,
      isPresentAccount:false,
      tipText:'',
      isTip:false,
      frontUrl:null,
      backUrl:null,
      isLookIdNo:false,
      code:false,
      time: 0,
      codeValue: '',
      inputFocus: false,
      signed:false,
      userType:[],
      mixinViewModuleOptions: {
        getDataListURL: '/loan/tcustbase/page',
        getDataListIsPage: true,
        exportURL: '/loan/tcustbase/export',
        // /loan/tcustrelationship
        deleteURL: '/loan/tcustrelationship',
        deleteIsBatch: true
      },
      addOrUpdateCVisible:false,
      addOrUpdateCVisiblev:false,
      addOrUpdateCloanVisible:false,//放款确认
      date:'',
      dataForm: {
        id: '',
        companyId:'',

      }
    }
  },
 created(){
  this.$bus.$on('aaa',()=>{
   
    this.addOrUpdateHandle()
  })
 },

  methods:{
    handleReceivedValue(value,data){
      console.log(7777,data);
      if(data){
        this.dataForm1 = data
      }
      
      if(value != null){
        this.isTip = true
      }     
      this.isPresentCapitalSide = value.isPresentCapitalSide
      this.isPresentAccount = value.isPresentAccount
      this.tipText = value.message
      this.custBaseId = value.custBaseId
      console.log(666,value);
    },
    changeHandle(custBaseId){
      this.addOrUpdateHandle(custBaseId)
      this.isTip = false
    },
    submitForm(){
      this.isDisabled = true
              this.$http[!this.dataForm1.id ? 'post' : 'put']('/loan/tcustbase/', this.dataForm1).then(({ data: res }) => {
                
                if (res.code !== 0) {
                  return this.$message.error(res.msg)
                }
          
                this.$message({
                  message: this.$t('prompt.success'),
                  type: 'success',
                  duration: 500,
                  onClose: () => {
                    this.isTip = false
                    this.getDataList()
                  }
                })
              }).catch(() => {})
              .finally(() => {
                this.isDisabled = false
              })
    },
    // 查看证件
    lookIdNo(item){
      console.log(555,item);
      this.isLookIdNo = true
      this.frontUrl = item.frontUrl
      this.backUrl = item.backUrl
      // this.$http.get(`/loan/UserRealNameAuthenticationController/showCommonBorrow?id=${item.id}`).then((res) => {
      //     console.log(23,res);
      // })
     
    },
    editRecord(){
      this.signed = false
      this.entering()
    },
    deldeda(){
    },
    // 支付密码
    codeOk(){
      this.code = false
      this.$router.push({
        path:'/loan-tloanapply',
      })
      console.log(this.codeValue)
    },
    getVerifyCode() {
      this.time = 120;
      const timer = setInterval(() => {
        this.time --;
        if (this.time <= 0) {
          this.time = 0;
          clearInterval(timer);
        }
      }, 1000);
    },
    // 验证码输入框input
    codeInputChange() {
      if (this.codeValue && this.codeValue.length >= 6) {
        // do soming...
      }
    },
    // 验证码输入框失去焦点
    codeInputBlur() {
      this.inputFocus = false;
    },
    // 验证码输入框获取到焦点
    codeInputFocus() {
      this.inputFocus = true;
    },
    // 列表的录入
    entering(id,row){
      if(!row.validityPeriod && row.borrowerType == 'PERSONAGE'){
        this.$message({
          message: '借款人身份证有效期为空，请通过”修改借款人“操作来获取。',
          type: 'error'
        })
        
      }else{
        this.isDisabled = true
        this.addOrUpdateCVisible = true
        this.isTip = false
      
        this.$nextTick(()=>{
          this.$refs.addOrUpdatec.infoid = id
          this.$refs.addOrUpdatec.getFormData()
          this.isDisabled = false
      
        })
      }
     
    },
    entering1(id){
       this.isDisabled = true
        this.addOrUpdateCVisible = true
        this.isTip = false
      
        this.$nextTick(()=>{
          this.$refs.addOrUpdatec.infoid = id
          this.$refs.addOrUpdatec.getFormData()
          this.isDisabled = false
      
        })
     
    },
    
    // 查看
    // enteringv(id){
    //   this.addOrUpdateCVisiblev = true
      
    //   this.$nextTick(()=>{
    //     this.$refs.addOrUpdatecv.infoid = id
    //    this.$refs.addOrUpdatecv.getFormData()
      
    //  })
    // },
     // 签约成功跳转页面到签约成功
     signedOK(){
      this.signed = false
      this.addOrUpdateCloanVisible = true
      this.$refs.addOrUpdatecloan.dialogVisibleok = true
      this.$nextTick(()=>{
        this.$refs.addOrUpdatecloan.dialogVisibleok = true
      })
      },
    showEntering(){
     this.addOrUpdateCVisible = true
     this.$nextTick(()=>{
      this.$refs.addOrUpdatec.dialogVisible = true
     })
    
     
    },
    getTimes() {
        if (this.date != null) {
          this.dataForm.startDate = this.date[0]
          this.dataForm.endDate = this.date[1]
        }else{
          this.dataForm.startDate =''
          this.dataForm.endDate = ''
        }
      }
  },
  watch:{
      $route:{
        handler(newVal,odlVal){
            this.dataForm.companyId = ''
            if(this.$refs.tree){
              this.$refs.tree.showDeptName = ''
            }
            // this.getDataList()
           
        },
        deep:true,
        immediate:true
      }
   },
  components: {
    AddOrUpdate,
    AddOrUpdatee,
    AddOrUpdateeloan,
    AddOrUpdateev,

    
  }
}
</script>

<style lang="scss" scoped>
.box-card{
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      width: 500px;
      height: 380px;
      text-align: center;
     h3{
      margin: 30px;
     }
     .card-btn{
      margin: 60px auto;
     }
      .footer-btn{
          height: 50px;
          width: 100%;
          display: flex;
          margin: 80px 0;
          justify-content: space-around;
          }
      p:nth-child(2){
          margin: 130px 0;
          span{
              color: blue;
          }
          
      }
    ul{
        width: 100%;
        margin: 30px 0;
        padding-left:168px ;
        
        li{
            width: 100%;
            text-align: left;
            margin: 5px 0;
            span:nth-child(1){
                width: 100px !important;
            }
            span{
                font-size: 12px;
                display: inline-block;
                text-align: left;
            }
            
        }
    }
  }
  .card-btn{
      display: flex;
      width: 82%;
      margin: 0 auto;
      justify-content: space-between;
      button{
          border: none;
          background: #3B46C4;
          width: 90px;
          height: 40px;
          border-radius: 4px;
          font-weight: 900;
          color: #fff;
      }
  }
  
  .mo{
      width: 200px;
      margin: 20px auto;
      height: 35px;
      line-height: 35px;
      background: #E9EAFA;
      border-radius: 4px;
      color: #3D4090;
      >span{
        background: #E9EAFA;
      }
    }
.box-card1{
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  width: 500px;
  height: 380px;
  text-align: center;
  .p2{
    margin: 20px 0;
  }
  .footer-btn{
    height: 50px;
    width: 100%;
    display: flex;
    margin: 60px 0;
    justify-content: space-around;
  }
}

.input-box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 80px;
    position: relative;
    padding: 0px 15px;
    box-sizing: border-box;
    .input-code {
      width: 100%;
      height: 50px;
      position: absolute;
      left: 0px;
      top: 0px;
      box-sizing: border-box;
      color: transparent;
      background-color: transparent;
      opacity: 0;
    }
    .code-item {
      width: 40px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      border-bottom: 1px solid#D8D8D8;
      margin-right: 10px;
      color: #444;
      font-size: 34px;
    }
    .code-item-active {
      border-bottom: 1px solid#F23026;
    }
  }
 .v-modal{
  display: none !important;
 }
 .look-idNo{
  border: 1px solid;
  padding: 2px 5px;
 }
 .look-dialog{
  display: flex;
  justify-content: space-around;
  font-size: 26px;
  color: #8c8c8c;
  .img-box{
    width: 300px;
    height: 200px;
    // border: 1px solid;
    img{
      width: 100%;
      height: 100%;
    }
   
  }
  .title{
    text-align: center;
  }
  .idNO-img{
    margin: 50px 0;
  }
 }
 .look-title{
  display: flex;
  align-items: center;
  img{
    width: 40px;
    margin-right:20px ;
  }
  span{
    color: #8c8c8c;
    font-size: 28px;
    font-weight: bold;
  }
 }
 
</style>
